import { FILE_TYPE, IMPREST_BUDGET_ID } from "../../../constants/filters";
import { FILE_TYPES } from "../../../constants/file";

export const GetFilter = id => {
  return filtersNormalize(id);
};

const filtersNormalize = id => {
  return {
    [FILE_TYPE]: FILE_TYPES.WEB,
    [IMPREST_BUDGET_ID]: id
  };
};
